const CHARCOAL = "#242424";
const CREAM = "#F4F0E8";
const GOLD = "#FFD700";
const MUTED = "#4F4F4F";
const MIST = "#B8B5AF";
const ZEBRA = "#EDE8DC";
const WHITE = "#FFFFFF";

export const downloadBlob = (filename, blob) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const drawAlignedText = (ctx, text, x, y, width, height, align) => {
  ctx.save();
  ctx.beginPath();
  ctx.rect(x, y, width, height);
  ctx.clip();
  ctx.textBaseline = "middle";
  const pad = 8;
  const ty = y + height / 2;
  const value = String(text ?? "");
  if (align === "right") {
    ctx.textAlign = "right";
    ctx.fillText(value, x + width - pad, ty);
  } else {
    ctx.textAlign = "left";
    ctx.fillText(value, x + pad, ty);
  }
  ctx.restore();
};

const columnWidthsFor = (headers, kind) => {
  if (kind === "column") {
    if (headers.length === 3) return [88, 140, 140];
    return [88, 180];
  }
  return [52, ...headers.slice(1).map(() => 44)];
};

export const drawPayoutExportCanvas = ({
  headers = [],
  rows = [],
  title = "Payout table",
  subtitle = "",
  kind = "column",
} = {}) => {
  const scale = 2;
  const pad = 32;
  const colWidths = columnWidthsFor(headers, kind);
  const tableWidth = colWidths.reduce((sum, width) => sum + width, 0);
  const isGrid = kind === "grid";
  const rowH = isGrid ? 22 : 28;
  const headerH = isGrid ? 26 : 32;
  const bannerH = subtitle ? 96 : 80;
  const footerH = 40;
  const width = tableWidth + pad * 2;
  const height = bannerH + 8 + headerH + rows.length * rowH + footerH;

  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(width * scale));
  canvas.height = Math.max(1, Math.round(height * scale));
  const ctx = canvas.getContext("2d");
  ctx.scale(scale, scale);
  ctx.fillStyle = CREAM;
  ctx.fillRect(0, 0, width, height);

  ctx.fillStyle = CHARCOAL;
  ctx.fillRect(0, 0, width, bannerH);
  ctx.fillStyle = GOLD;
  ctx.font = "600 12px 'Segoe UI', system-ui, sans-serif";
  ctx.textAlign = "left";
  ctx.textBaseline = "alphabetic";
  ctx.fillText("BOWLING TOURNAMENT APP", pad, 28);
  ctx.fillStyle = CREAM;
  ctx.font = "bold 22px 'Segoe UI', system-ui, sans-serif";
  ctx.fillText(title, pad, 58);
  if (subtitle) {
    ctx.fillStyle = MIST;
    ctx.font = "13px 'Segoe UI', system-ui, sans-serif";
    ctx.fillText(subtitle, pad, 80);
  }

  ctx.fillStyle = GOLD;
  ctx.fillRect(0, bannerH, width, 3);

  const tableX = pad;
  let y = bannerH + 11;
  ctx.fillStyle = CHARCOAL;
  ctx.fillRect(tableX, y, tableWidth, headerH);
  ctx.fillStyle = CREAM;
  ctx.font = isGrid
    ? "bold 11px 'Segoe UI', system-ui, sans-serif"
    : "bold 13px 'Segoe UI', system-ui, sans-serif";
  let x = tableX;
  headers.forEach((label, index) => {
    drawAlignedText(
      ctx,
      label,
      x,
      y,
      colWidths[index],
      headerH,
      index === 0 ? "left" : "right"
    );
    x += colWidths[index];
  });
  y += headerH;

  rows.forEach((row, rowIndex) => {
    ctx.fillStyle = rowIndex % 2 === 0 ? WHITE : ZEBRA;
    ctx.fillRect(tableX, y, tableWidth, rowH);
    ctx.fillStyle = CHARCOAL;
    ctx.font = isGrid
      ? "12px 'Segoe UI', system-ui, sans-serif"
      : "14px 'Segoe UI', system-ui, sans-serif";
    x = tableX;
    row.forEach((cell, index) => {
      drawAlignedText(
        ctx,
        cell,
        x,
        y,
        colWidths[index],
        rowH,
        index === 0 ? "left" : "right"
      );
      x += colWidths[index];
    });
    y += rowH;
  });

  ctx.strokeStyle = "rgba(36, 36, 36, 0.12)";
  ctx.strokeRect(
    tableX + 0.5,
    bannerH + 11.5,
    tableWidth - 1,
    headerH + rows.length * rowH - 1
  );

  ctx.fillStyle = MUTED;
  ctx.font = "11px 'Segoe UI', system-ui, sans-serif";
  ctx.textAlign = "left";
  ctx.textBaseline = "alphabetic";
  ctx.fillText("bowlingtournamentapp.com", pad, height - 16);

  return canvas;
};

export const downloadPayoutExportPng = ({ filename, ...model }) =>
  new Promise((resolve, reject) => {
    const canvas = drawPayoutExportCanvas(model);
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error("Could not build the image."));
        return;
      }
      downloadBlob(filename, blob);
      resolve();
    }, "image/png");
  });
